module.exports = __webpack_public_path__ + "static/google-cloud-cbam-india-b90863fdb4ca88161b9aabd390f4a4e6.png";